import { render, staticRenderFns } from "./OurEthics.vue?vue&type=template&id=277bf058&scoped=true&"
import script from "./OurEthics.vue?vue&type=script&lang=ts&"
export * from "./OurEthics.vue?vue&type=script&lang=ts&"
import style0 from "./OurEthics.vue?vue&type=style&index=0&id=277bf058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277bf058",
  null
  
)

export default component.exports